var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMevProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.28 67.1306L172.096 68.0499C171.577 67.5549 170.987 67.2485 170.28 67.1306Z",
    stroke: "url(#paint0_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.28 67.1306L172.096 68.0499C171.577 67.5549 170.987 67.2485 170.28 67.1306Z",
    stroke: "url(#paint1_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.786 233.804C128.889 240.24 116.42 239.934 106.355 232.909C103.667 231.046 101.334 228.784 99.3774 226.144C96.4309 222.184 94.286 217.375 92.9424 211.694C94.1445 211.27 95.3938 210.775 96.6431 210.233L112.507 218.176L143.786 233.804Z",
    stroke: "url(#paint2_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.07 112.741C222.562 112.034 220.747 112.293 218.625 113.519C216.362 114.815 214.595 116.725 213.275 119.2C211.955 121.675 211.318 124.055 211.318 126.365C211.318 135.393 209.904 144.633 207.099 154.085C204.27 163.538 200.428 172.825 195.549 181.947C194.724 179.566 193.357 177.893 191.424 176.926L191.117 176.785C190.835 176.643 190.528 176.525 190.198 176.431C187.652 175.606 184.682 176.172 181.288 178.128L173.792 182.465V156.631C173.792 154.18 173.062 152.553 171.624 151.728L171.176 151.516C169.832 150.974 168.206 151.233 166.297 152.341L164.576 153.331L155.124 158.8L121.275 178.34V161.133L126.65 158.022L136.267 152.459C138.412 151.233 140.18 149.371 141.617 146.896C143.055 144.421 143.786 141.946 143.786 139.518V122.288L158.777 113.637C160.616 112.576 162.313 111.256 163.916 109.653C165.92 107.673 167.734 105.293 169.384 102.464C169.927 101.545 170.398 100.625 170.822 99.7297C172.614 96.0525 173.58 92.4933 173.745 89.0047C173.792 88.5804 173.792 88.1797 173.792 87.7554V73.1175C173.792 72.5283 173.745 71.9861 173.675 71.4675C173.462 69.9825 172.944 68.8511 172.095 68.0497L170.28 67.1304H170.257C169.479 66.989 168.583 67.0833 167.593 67.4368C164.977 68.2383 162.313 69.2518 159.626 70.5247C156.939 71.7975 154.157 73.259 151.282 74.909C148.005 76.7947 144.8 78.869 141.665 81.179C134.923 86.0347 128.417 91.8097 122.195 98.4804C113.072 108.263 105.105 119.035 98.2932 130.797C95.5589 135.511 93.0603 140.273 90.8211 145.128C87.4032 152.412 84.5275 159.837 82.1468 167.45C81.3218 170.09 80.591 172.73 79.9546 175.323C77.4796 185.247 76.2539 194.911 76.2539 204.34C76.2539 208.017 76.4422 211.529 76.8665 214.853C77.5972 221.453 79.1061 227.393 81.4161 232.625C81.6282 233.191 81.8875 233.757 82.1468 234.299C86.1068 242.479 91.4811 248.537 98.2932 252.426C105.105 256.316 113.072 257.871 122.195 257.117C131.34 256.363 141.028 253.039 151.282 247.123C161.653 241.112 171.388 233.238 180.439 223.503C189.514 213.745 197.458 202.973 204.27 191.234C211.082 179.472 216.457 167.215 220.417 154.463C224.353 141.71 226.31 129.383 226.31 117.479C226.31 115.051 225.555 113.472 224.07 112.741ZM143.786 233.804C128.889 240.24 116.42 239.933 106.355 232.908C103.667 231.046 101.334 228.783 99.3775 226.143C96.431 222.183 94.286 217.375 92.9425 211.694C91.9053 207.333 91.3396 202.478 91.2689 197.103C91.2453 196.632 91.2453 196.137 91.2453 195.665V195.43C91.2453 192.931 91.4103 190.315 91.7168 187.651C91.9525 185.671 92.1882 183.691 92.4475 181.688C92.5418 180.886 92.636 180.108 92.7539 179.307L128.771 199.838V208.441C128.771 213.179 130.232 216.385 133.179 218.058C136.125 219.732 139.661 219.378 143.786 216.998V233.804Z",
    stroke: "url(#paint3_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.786 216.998V233.805L112.507 218.177L96.6431 210.233V199.791L120.757 211.836L133.179 218.059C136.125 219.732 139.661 219.379 143.786 216.998Z",
    stroke: "url(#paint4_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.771 199.838L92.4478 181.688C92.542 180.886 92.6363 180.108 92.7542 179.307L128.771 199.838Z",
    stroke: "url(#paint5_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.178 218.058L120.757 211.835L96.6427 199.79L91.2687 197.103C91.2451 196.632 91.2451 196.137 91.2451 195.665V195.43C91.2451 192.931 91.4101 190.315 91.7165 187.651C91.9523 185.671 92.188 183.691 92.4473 181.688L128.771 199.838V208.441C128.771 213.179 130.232 216.385 133.178 218.058Z",
    stroke: "url(#paint6_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.257 67.1306C169.479 66.9892 168.583 67.0835 167.593 67.4371C164.977 68.2385 162.313 69.2521 159.626 70.5249C156.939 71.7978 154.158 73.2592 151.282 74.9092C148.006 76.7949 144.8 78.8692 141.665 81.1792C134.923 86.0349 128.418 91.8099 122.195 98.4806C113.073 108.263 105.106 119.035 98.2935 130.797C95.5592 135.511 93.0606 140.273 90.8213 145.128C87.4035 152.412 84.5278 159.837 82.147 167.451C81.322 170.091 80.5913 172.731 79.9549 175.323C77.4799 185.247 76.2542 194.911 76.2542 204.34C76.2542 208.017 76.4425 211.529 76.8668 214.853C77.5975 221.453 79.1063 227.393 81.4163 232.626C81.6285 233.191 81.8878 233.757 82.147 234.299C86.107 242.479 91.4813 248.537 98.2935 252.426L53.8847 230.268L53.0599 229.868C52.4235 229.561 51.787 229.208 51.1506 228.854C44.3384 224.965 38.9642 218.907 35.0042 210.728C31.0678 202.525 29.1113 192.531 29.1113 180.768C29.1113 169.006 31.0678 156.561 35.0042 143.879C38.9642 131.198 44.3384 118.988 51.1506 107.226C57.9628 95.4635 65.9299 84.6913 75.052 74.9092C84.1978 65.1271 93.8856 57.2542 104.139 51.3378C107.015 49.6878 109.796 48.2263 112.483 46.9535C115.171 45.6806 117.834 44.6671 120.451 43.8656C122.336 43.2056 123.845 43.4178 124.953 44.4785L141.924 52.9642L170.257 67.1306Z",
    stroke: "url(#paint7_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.983 30.1472C218.248 29.0158 215.019 29.5106 211.319 31.6556C209.527 32.6927 207.854 33.9658 206.298 35.5215C204.247 37.5251 202.385 39.9527 200.711 42.8284C200.523 43.1584 200.334 43.4886 200.169 43.8186C197.576 48.5329 196.303 53.1058 196.303 57.5372V66.1408L185.508 60.7427L149.161 42.5694V33.9658C149.161 29.2279 150.622 24.3248 153.568 19.2571C156.515 14.1892 160.051 10.465 164.176 8.08424C168.301 5.70353 171.836 5.35 174.759 7.02357L220.983 30.1472Z",
    stroke: "url(#paint8_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231.213 47.9905C229.869 47.4248 228.219 47.7076 226.31 48.8155V45.5391L231.213 47.9905Z",
    stroke: "url(#paint9_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.303 66.1405C194.181 67.3662 192.39 69.2284 190.952 71.7034C189.514 74.1784 188.807 76.6534 188.807 79.0812V104.916C188.807 107.343 189.514 108.993 190.952 109.795L178.718 103.666L170.822 99.7298C172.613 96.0527 173.58 92.4934 173.745 89.0048C173.792 88.5805 173.792 88.1798 173.792 87.7555V73.1177C173.792 72.5284 173.745 71.9862 173.674 71.4677C173.462 69.9827 172.943 68.8512 172.095 68.0498C171.576 67.5548 170.987 67.2484 170.28 67.1305H170.256L141.923 52.9641C142.23 51.3612 142.866 49.7584 143.809 48.1319C145.247 45.6569 147.038 43.7948 149.16 42.5691L185.507 60.7427L196.303 66.1405Z",
    stroke: "url(#paint10_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M231.66 48.2027L231.213 47.9903C229.869 47.4246 228.219 47.7077 226.31 48.8155V40.2119C226.31 35.4741 224.848 32.2684 221.902 30.5948L220.983 30.1469C218.248 29.0155 215.019 29.5105 211.318 31.6555C209.527 32.6927 207.853 33.9655 206.298 35.5212C204.247 37.5248 202.385 39.9524 200.711 42.8281C200.523 43.1581 200.334 43.4884 200.169 43.8184C197.576 48.5327 196.303 53.1055 196.303 57.5369V66.1405C194.182 67.3662 192.39 69.2281 190.953 71.7031C189.515 74.1781 188.808 76.6531 188.808 79.081V104.916C188.808 107.343 189.515 108.993 190.953 109.795C192.39 110.62 194.182 110.431 196.303 109.182L205.897 103.643L226.31 91.8569C228.431 90.6312 230.223 88.7924 231.66 86.2938C233.098 83.8188 233.829 81.3677 233.829 78.9162V53.0819C233.829 50.6541 233.098 49.0277 231.66 48.2027ZM218.814 53.1527L203.799 61.8034V53.1998C203.799 51.0077 204.388 48.7684 205.59 46.5291C205.708 46.2934 205.826 46.0577 205.968 45.8219C207.405 43.3469 209.173 41.4846 211.318 40.2588C212.19 39.7403 213.039 39.4105 213.793 39.2691C214.854 39.0334 215.797 39.1748 216.645 39.6462C217.376 40.0705 217.918 40.6831 218.272 41.5081C218.625 42.3096 218.814 43.3231 218.814 44.5253V53.1527Z",
    stroke: "url(#paint11_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M218.814 44.5251V53.1523L205.59 46.529C205.708 46.2932 205.826 46.0575 205.967 45.8218C207.405 43.3468 209.173 41.4844 211.318 40.2587C212.19 39.7402 213.039 39.4104 213.793 39.269C214.854 39.0332 215.797 39.1747 216.645 39.6461C217.376 40.0704 217.918 40.683 218.272 41.508C218.625 42.3094 218.814 43.323 218.814 44.5251Z",
    stroke: "url(#paint12_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M218.813 53.1529L203.798 61.8038V53.2002C203.798 51.0081 204.388 48.7686 205.59 46.5293L218.813 53.1529Z",
    stroke: "url(#paint13_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.07 112.741C222.561 112.034 220.746 112.293 218.625 113.519C216.362 114.815 214.594 116.725 213.274 119.2C211.954 121.675 211.318 124.055 211.318 126.365C211.318 135.393 209.903 144.633 207.098 154.085C204.27 163.538 200.428 172.825 195.548 181.947C194.723 179.566 193.356 177.893 191.423 176.926L191.117 176.785L173.792 168.134V156.631C173.792 154.18 173.061 152.553 171.623 151.728L171.175 151.516L166.485 149.159L155.335 143.596C157.103 139.283 158.635 134.922 159.955 130.514C162.053 123.443 163.373 116.489 163.915 109.653C165.919 107.673 167.734 105.293 169.384 102.464C169.926 101.545 170.398 100.625 170.822 99.7297L178.718 103.666L190.952 109.795C192.39 110.62 194.181 110.431 196.303 109.182L205.896 103.643L224.07 112.741Z",
    stroke: "url(#paint14_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M171.176 151.517C169.833 150.974 168.206 151.234 166.297 152.342L164.576 153.332L155.124 158.8L121.275 178.341V161.134L126.65 158.022L136.267 152.459C138.412 151.234 140.18 149.372 141.618 146.897C143.055 144.422 143.786 141.947 143.786 139.519V137.822L155.336 143.597L166.485 149.159L171.176 151.517Z",
    stroke: "url(#paint15_linear_2501_1441)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_1441",
    x1: 171.188,
    y1: 67.1306,
    x2: 171.188,
    y2: 68.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2501_1441",
    x1: 171.188,
    y1: 67.1306,
    x2: 171.188,
    y2: 68.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2501_1441",
    x1: 118.364,
    y1: 210.233,
    x2: 118.364,
    y2: 238.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2501_1441",
    x1: 151.282,
    y1: 67.0674,
    x2: 151.282,
    y2: 257.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2501_1441",
    x1: 120.214,
    y1: 199.791,
    x2: 120.214,
    y2: 233.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2501_1441",
    x1: 110.61,
    y1: 179.307,
    x2: 110.61,
    y2: 199.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2501_1441",
    x1: 112.212,
    y1: 181.688,
    x2: 112.212,
    y2: 218.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2501_1441",
    x1: 99.6842,
    y1: 43.4897,
    x2: 99.6842,
    y2: 252.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2501_1441",
    x1: 185.072,
    y1: 5.9873,
    x2: 185.072,
    y2: 66.1408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2501_1441",
    x1: 228.761,
    y1: 45.5391,
    x2: 228.761,
    y2: 48.8155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2501_1441",
    x1: 169.113,
    y1: 42.5691,
    x2: 169.113,
    y2: 109.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2501_1441",
    x1: 211.318,
    y1: 29.5576,
    x2: 211.318,
    y2: 110.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2501_1441",
    x1: 212.202,
    y1: 39.157,
    x2: 212.202,
    y2: 53.1523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2501_1441",
    x1: 211.306,
    y1: 46.5293,
    x2: 211.306,
    y2: 61.8038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2501_1441",
    x1: 189.703,
    y1: 99.7297,
    x2: 189.703,
    y2: 181.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2501_1441",
    x1: 146.226,
    y1: 137.822,
    x2: 146.226,
    y2: 178.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMevProtection);
export default __webpack_public_path__ + "static/media/MEV-Protection.34e51eb12acf6bfca155fab97f74713f.svg";
export { ForwardRef as ReactComponent };